import { callPlanet } from './'

// export type FiltersApiResponse = {|
//   +products: Array<FiltersProduct>,
// |}

// export type FiltersApiRequest = {|
//   +status: number,
//   +response: FiltersApiResponse
// |}

export const filtersCall = (
  countryCode,
  cultureCode,
  departureCities,
  departureDates,
  durations,
  marketId,
  operationCode,
  saleKey,
  isResourceV2 = false
) => {
  const uri = isResourceV2
    ? 'Search/v2/Product'
    : 'Search/Product'

  const body = {
    countryCode,
    cultureCode,
    departureCities,
    departureDates,
    durations,
    eventKey: saleKey,
    marketId,
    operationCode
  }

  return callPlanet(uri, body)
}

// export type FiltersPackagesApiResponse = {|
//   +packages: Array<FilteredPackages>
// |}

// export type FiltersPackagesApiRequest = {|
//   +status,
//   +response: FiltersPackagesApiResponse
// |}

export const fetchFilteredPackages = (
  countryCode,
  cultureCode,
  departureCities,
  departureDates,
  durations,
  marketId,
  operationCode,
  productKey,
  saleKey,
  isResourceV2 = false
) => {
  const uri = isResourceV2
    ? 'Search/v2/Product/Packages'
    : 'Search/Product/Packages'

  const body = {
    campaignCode: operationCode,
    countryCode,
    cultureCode,
    departureCities,
    departureDates,
    durations,
    eventKey: saleKey,
    marketId,
    productKey
  }

  return callPlanet(uri, body)
}
